import React from "react";
import { SectionArticle } from "../../shared/ArticleTemplate";

const Crest = ({parentPath}) =>
  <SectionArticle sectionName="crest" backRoute={parentPath}/>

export default Crest;